import getAddressDefinitions from '../getAddressDefinitions';
import { getSelectedDeliveryData } from './DeliveryAddressSelectors';

const getDeliveryAddressDataOrFalseIfInvalid = (state) => {
  const addressDefinitions = getAddressDefinitions(state);
  const deliveryData = getSelectedDeliveryData(state, addressDefinitions);
  
  if (!deliveryData) {
    return false;
  }
  
  return deliveryData;
};

export default getDeliveryAddressDataOrFalseIfInvalid;